
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { ISelectedFacetValue } from '../../../types/Search';

import UiChip from '../../../components/UiChip.vue';

@Component({
	name: 'SelectedFacet',
	components: {
		UiChip,
	}
})
class SelectedFacet extends Vue {
	@Prop({ type: Object as () => ISelectedFacetValue, default: '' })
	facetValue: ISelectedFacetValue;

	remove() {
		this.$store.dispatch('deselectFacetValue', this.facetValue.value);
	}

	get arialabel() {
		return `Remove filter ${this.facetValue.facetName}: ${this.facetValue.value.label}`;
	}
}

export default SelectedFacet;
